module.exports = __webpack_public_path__ + "img/LDSJ_STILL1.0ca6f1f0.jpg";